import React from 'react';
import useDimensions from 'react-cool-dimensions';
import { checkOverflow } from 'utils/DomUtil';

export default function useIsElementScrollable() {
  const elementRef = React.useRef<HTMLDivElement | null>(null);
  const [isScrollable, setIsScrollable] = React.useState(false);
  const { observe, width, height } = useDimensions();

  React.useEffect(() => {
    setIsScrollable(checkOverflow(elementRef.current));
  }, [width, height, elementRef]);

  const observeElement = React.useCallback(
    (element?: HTMLDivElement | null | undefined) => {
      if (element) {
        observe(element);
        elementRef.current = element;
      }
    },
    [observe],
  );

  return { isScrollable, observeElement };
}
